import { Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import BackIcon from "../../assets/icons/back.png";

const BackButton = () => {

    const navigate = useNavigate();

    return(
        <Button startIcon={<img alt="back-icon" src={BackIcon} style={{height: 22}} />}
            style={{color: "#3333CFCE", fontSize: 16, textTransform: "none", fontWeight : 600}}
            onClick={() => navigate(-1)}
        >
            Back
        </Button>
    )
}

export default BackButton